import styled from 'styled-components'

import { helpers } from 'styles'

export const Title = styled.span`
	display: flex;
	align-items: center;
	gap: 4px;
	font-family: ${helpers.font.family.code};
	font-weight: 600;
	margin-bottom: 6px;
	font-size: 13px;
	color: ${helpers.color.textHeader};
	line-height: 13px;
	flex-wrap: wrap;

	&:only-child {
		margin: 0;
	}
`
